window.lang2 = 
{
  "general": {
    "meta": {
      "tags": "Mots clés \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "404": {
      "title": "404 - Page non trouvée",
      "subtext_html": "Cette page n'est pas disponible. <a href=\"\/collections\/all\">Retourner au magasinage<\/a>"
    },
    "breadcrumbs": {
      "home": "Accueil",
      "home_link_title": "Retour à la page d'accueil"
    },
    "newsletter_form": {
      "title": "Joignez-vous à notre Lettre Email",
      "newsletter_email": "courriel@exemple.com",
      "submit": "Inscrivez-vous maintenant !",
      "noitice": "Don’t show this popup again"
    },
    "search": {
      "no_results_html": "Votre recherche pour \"{{ terms }}\" n'a pas généré de résultats.",
      "results_for_html": "Votre recherche pour \"{{ terms }}\" a généré les résultats suivants:",
      "title": "Effectuez une recherche",
      "placeholder": "Parcourez le magasin entier ici.",
      "submit": "Recherche"
    },
    "date": {
      "year_text": "années",
      "month_text": "mois",
      "week_text": "semaines",
      "day_text": "journées",
      "year_singular_text": "années",
      "month_singular_text": "mois",
      "week_singular_text": "semaines",
      "day_singular_text": "journées",
      "hour_text": "Heures",
      "min_text": "Mins",
      "sec_text": "Secs",
      "hour_singular_text": "Heure",
      "min_singular_text": "Min",
      "sec_singular_text": "Sec"
    },
    "modal": {
      "wishlist_text": "Excl. affranchissement",
      "continue_shopping": "Continuer vos achats",
      "go_to_wishlist": "Ma liste d'envies",
      "add_to_wishlist_message": "Venez d'ajouter à votre liste:",
      "cart_text": "Excl. affranchissement",
      "go_to_cart": "Mon panier",
      "add_to_cart_message": "Juste ajouté à votre panier:",
      "qty": "Quantité:",
      "total": "Le total:"
    }
  },
  "header": {
    "settings": {
      "login": "Connectez-vous ou créez un compte",
      "register": "Enregistrer",
      "logout": "Se déconnecter",
      "my_account": "Mon compte",
      "wishlist": "Ma liste d'envies",
      "currency": "Devise",
      "newsletter_signup": "Inscription à la newsletter",
      "language": "vos Langues",
      "hotline":"hotline:",
      "account":"compte"
      
    },
    "topbar": {
      "my_cart": "Ma page",
      "search": "Search"
    }
  },
  "blogs": {
    "article": {
      "by":"Par",
      "author_on_date_html": "Publié par {{ author }} le {{ date }}",
      "older_post": "Article précédent",
      "newer_post": "Article suivant",
      "tags": "Tags",
      "comment_meta_html": "{{ author }} le {{ date }}",
      "read_more": "Plus",
      "comment":" commentaires"
    },
    "comments": {
      "title": "Envoyer un commentaire",
      "name": "Nom",
      "email": "Courriel",
      "message": "Commentaire",
      "post": "Envoyer un commentaire",
      "moderated": "Veuillez noter que les commentaires doivent être approvés avant d'être affichés",
      "success_moderated": "Votre commentaire a été soumis avec succès. Nous le publierons sous peu, suite à notre processus de modération.",
      "success": "Votre commentaire a été publié avec succès!",
      "comments_with_count": {
        "one": "{{ count }} article(s)",
        "other": "{{ count }} article(s)"
      }
    },
    "sidebar": {
      "heading":"blog",
      "recent_articles": "Articles récents",
      "categories": "Catégories",
      "video": "Dernière vidéo",
      "tags": "Mots clés"
    }
  },
  "cart": {
    "general": {
      "title": "Panier",
      "remove": "Retirer",
      "edit": "modifier",
      "note": "Instructions spéciales pour la commande",
      "subtotal": "Sous-total",
      "grandtotal": "Total",
      "shipping_at_checkout": "Frais de port et remises calculés à la caisse",
      "update": "Mettre à jour son panier",
      "checkout": "Procéder au paiement",
      "empty": "Votre panier est vide.",
      "continue_browsing_html": "<a href=\"\/collections\/all\">Retourner au magasinage<\/a>.",
      "close_cart": "Fermer le panier",
      "shipping_calculator_error_message": "Erreur: Veuillez entrer vois information sur la livraison correctes",
      "shipping_calculator_success_many_rates": {
        "there_are": "Il y a",
        "shipping_rates_available_for": "Tarifs d'expédition disponibles pour",
        "starting_at": ", à partir de"
      },
      "shipping_calculator_success_one_rate": "Il ya un tarif disponible pour d'expédition",
      "shipping_calculator_success_no_rate": "Il n'y a aucune tarif disponible pour cet ordre et de destination expédition.",
      "shipping_calculator_success_at": "à"
    },
    "header": {
      "view_cart": "Voir le panier",
      "checkout": "Check-out",
      "total": "Sous-Total:",
      "you_have":"tu as",
      "item":"article(s)",
      "total_numb": "dans votre sac",
      "no_item": "Vous avez pas d'articles dans votre panier.",
      "remove_this_item": "Supprimer un objet"
    },
    "label": {
      "product": "Produit",
      "product-image": "Image du produit",
      "price": "Prix unitaire",
      "quantity": "Quantité",
      "update_cart": "Update Cart",
      "remove": "Remove",
      "total": "Total"
    },
    "shipping": {
      "title": "Obtenez des estimations d'expédition",
      "country": "Pays",
      "state": "Etat",
      "zip": "Zip\/code postal",
      "submit_button": "expédition Calculez",
      "submit_button_when_calculating": "Calculateur..."
    }
  },
  "collections": {
    "general": {
      "title": "Liste Collections",
      "all_of_collection": "Tout",
      "no_matches": "Aucun produit ne correspond à votre recherche.",
      "link_title": "Consultez la collection {{ title }}",
      "view_as":"Voir comme:",
      "grid": "la grille",
      "list": "liste",
      "view_all":"Voir tout",
      "shop_the_collection": "Boutique La Collection",
      "items_with_count": {
        "one": "{{ count }} item",
        "other": "{{ count }} items"
      },
      "clear": "Clair",
      "refine_by": "Affiner par",
      "clear_all": "Tout effacer",
      "filter": "Filtre",
      "showing": "Résultats",
      "of": "De",
      "items":"articles",
      "page":"page:",
      "previous": "Précédent",
      "next": "Suivant Suivant",
      "show_more": "Montre plus",
      "no_more_product": "Pas plus produit"
    },
    "sidebar": {
      "categories": "Catégories",
      "shopby": "Magasiner par",
      "tags": "Filtres"
    },
    "sorting": {
      "title": "Trier par",
      "featured": "En vedette",
      "best_selling": "Meilleurs vendeurs",
      "az": "A-Z",
      "za": "Z-A",
      "price_ascending": "Prix: faible à élevé",
      "price_descending": "Prix: élevé à faible",
      "date_descending": "Date: récent à ancien",
      "date_ascending": "Date: ancien à récent",
      "limit_18": "18",
      "limit_24": "24",
      "limit_48": "48",
      "limit_all": "TOUT"
    },
    "limiter": {
      "title": "montrer",
      "limit_18": "18 article",
      "limit_24": "24 article",
      "limit_48": "48 article",
      "limit_all": "TOUT"
    },
    "onboarding": {
      "modal_title": "Cette page affichera tous les produits de votre magasin",
      "no_products_html": "Il n'y a aucun produit pour l'instant, mais dès que vous commencerez à les ajouter, ils s'afficheront ici, qu'ils soient dans une collection ou non.",
      "add_product": "Ajouter un produit"
    }
  },
  "contact": {
    "form": {
      "title": "Formulaire de contact",
      "name": "Nom",
      "email": "Courriel",
      "phone": "Téléphone",
      "message": "Message",
      "send": "Envoyer un message",
      "post_success": "Merci de nous avoir avoir contacté. Nous vous reviendrons le plus rapidement possible."
    }
  },
  "customer": {
    "account": {
      "title": "Mon compte",
      "details": "Détails du compte",
      "view_addresses": "Voir les adresses",
      "return": "Retour au détails du compte"
    },
    "activate_account": {
      "title": "Activer le compte",
      "subtext": "Créez votre mot de passe pour activer le compte.",
      "submit": "Activer le compte",
      "cancel": "Refuser l'invitation",
      "password": "Mot de passe",
      "password_confirm": "Confirmer le mot de passe"
    },
    "addresses": {
      "title": "Votre adresse",
      "default": "Par défaut",
      "add_new": "Ajouter une nouvelle adresse",
      "edit_address": "Éditer l'adresse",
      "first_name": "Prénom",
      "last_name": "Nom",
      "company": "Compagnie",
      "address1": "Adresse 1",
      "address2": "Adresse 2",
      "city": "Ville",
      "country": "Pays",
      "province": "Province",
      "zip": "Code postal",
      "phone": "Téléphone",
      "set_default": "Définir comme adresse par défaut",
      "add": "Ajouter l'adresse",
      "update": "Mettre à jour l'adresse",
      "cancel": "Annuler",
      "edit": "Éditer",
      "delete": "Supprimer",
      "delete_message": "Etes-vous sûr que vous voulez supprimer cette adresse?"
    },
    "login": {
      "heading":"Identifiez-vous ou créez un compte",
      "page_title": "Login",
      "title": "Déjà enregistré",
      "content": "Si vous avez un compte avec nous, s'il vous plaît connecter.",
      "email": "Adresse e-mail",
      "password": "Mot de passe",
      "forgot_password": "Mot de passe oublié?",
      "sign_in": "S'identifier",
      "cancel": "Retourner à la boutique",
      "guest_title": "Continuer en tant qu'invité",
      "guest_continue": "Continuer",
      "register": "Nouveaux clients",
      "register_content": "En créant un compte sur notre boutique, vous serez en mesure de se déplacer à travers le processus de paiement plus rapide, stocker les adresses de livraison multiples, consulter et suivre vos commandes dans votre compte et plus encore.",
      "register_button": "Créer un compte"
    },
    "logout": {
      "title": "Se déconnecter"
    },
    "orders": {
      "title": "Historique des commandes",
      "order_number": "Commande",
      "date": "Date",
      "payment_status": "Statut du paiement",
      "fulfillment_status": "Statut du traitement de la commande",
      "total": "Total",
      "none": "Vous n'avez pas placé de commande à ce jour."
    },
    "order": {
      "title": "Commande {{ name }}",
      "date": "Placée le {{ date }}",
      "cancelled": "Commande annulée le {{ date }}",
      "cancelled_reason": "Motif: {{ reason }}",
      "billing_address": "Adresse de facturation",
      "payment_status": "Statut du paiement",
      "shipping_address": "Adresse de livraison",
      "fulfillment_status": "Statut du traitement de la commande",
      "discount": "Rabais appliqué",
      "shipping": "Livraison",
      "tax": "Taxes",
      "product": "Produit",
      "sku": "SKU",
      "price": "Prix",
      "quantity": "Quantité",
      "total": "Total",
      "fulfilled_at": "Traitée le {{ date }}",
      "subtotal": "Sous-total"
    },
    "recover_password": {
      "title": "Réinitialiser votre mot de passe",
      "email": "Courriel",
      "submit": "Soumettre",
      "cancel": "Annuler",
      "subtext": "Nous vous ferons parvenir un courriel pour réinitialiser votre mot de passe.",
      "success": "Nous vous avons fait parvenir un courriel pour réinitialiser votre mot de passe."
    },
    "reset_password": {
      "title": "Réinitialiser le mot de passe du compte",
      "subtext": "Entrez un nouveau mot de passe pour {{ email }}",
      "submit": "Réinitialiser le mot de passe",
      "password": "Mot de passe",
      "password_confirm": "Confirmer le mot de passe"
    },
    "register": {
      "page_title": "Registre",
      "title": "Créer un compte",
      "first_name": "Prénom",
      "last_name": "Nom",
      "email": "Courriel",
      "submit": "Créer",
      "cancel": "Retour à la boutique",
      "password": "Mot de passe",
      "message": "S'il vous plaît entrer les informations ci-dessous pour créer votre compte."
    }
  },
  "homepage": {
    "sections": {
      "frontpage_title": "Collection Frontpage",
      "featured_title": "Collections en vedette",
      "news_title": "Nouvelles récentes"
    },
    "onboarding": {
      "modal_title": "Nous y sommes presque...",
      "no_products_html": "Vous n'avez pas de produit dans votre collection Frontpage. Ce message apparaitra jusqu'à ce qu'un produit soit <a href=\"\/admin\/collections?tutorial=Frontpage\">ajouté à cette collection<\/a>.",
      "add_product": "Ajouter un produit",
      "product_title": "Titre du produit",
      "no_collections_html": "Vous n'avez pas de collection à afficher ici. <a href=\"\/admin\/custom_collections\">Ajoutez une ou plusieurs collections<\/a> pour compléter la page d'accueil par défaut.",
      "add_collection": "Ajouter une collection",
      "collection_title": "Titre de la collection"
    }
  },
  "layout": {
    "navigation": {
      "menu": "Menu"
    },
    "drawers": {
      "browse": "Explorer",
      "close_menu": "Fermer le menu"
    },
    "cart": {
      "title": "Panier",
      "items_count": {
        "one": "élément",
        "other": "éléments"
      }
    },
    "customer": {
      "account": "Compte",
      "logged_in_as_html": "Connecté en tant que {{ first_name }}",
      "log_out": "Se déconnecter",
      "log_in": "Se connecter",
      "create_account": "Créer un compte"
    },
    "footer": {
      "social_title": "Restez en contact",
      "newsletter_title": "Infolettre",
      "accepted_payments": "Méthodes de paiement acceptées"
    }
  },
  "wish_list": {
    "general": {
      "add_to_wishlist": "Ajouter à la liste de souhaits",
      "browse_wishlist": "Parcourir la liste de souhaits",
      "image": "Image du produit",
      "item": "Nom du produit",
      "price": "Prix",
      "add_to_cart": "Ajouter au panier",
      "remove": "Retirer",
      "note": "Partager ma liste de souhaits par courriel",
      "to_create_a_wishlist_please": "Pour créer une liste s'il vous plaît",
      "login": "S'identifier",
      "or": "ou",
      "register": "créer un compte",
      "no_products_html": "Pas de produits trouvés dans votre liste de souhaits."
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Produit précédent",
      "next_product_html": "Produit suivant &rarr;",
      "from_text_html": "À partir de {{ price }}",
      "sale_price": "Prix réduit",
      "regular_price": "Prix régulier",
      "related_products": "Produits Alternatifs",
      "sale": "Vente",
      "show_more": "Montre plus",
      "no_more_product": "Pas plus de produits"
    },
    "product": {
      "sold_out": "Épuisé",
      "on_sale": "En solde",
      "on_sale_from_html": "<strong>En solde<\/strong> {{ price }}",
      "unavailable": "Non disponible",
      "compare_at": "Était",
      "quantity": "Quantité",
      "add_to_cart": "Ajouter au panier",
      "select_options": "Select Options",
      "tab_title_description": "Description du produit",
      "tab_title_review": "Avis client",
      "share": "Partager:",
      "availability": "Disponibilité:",
      "sku": "Code produit:",
      "in_stock": "En stock",
      "out_of_stock": "Rupture de stock",
      "many_in_stock": "Beaucoup En Stock",
      "product_type": "Type de produit:",
      "product_vendor": "Vendeur:",
      "count_down": "Offres d'une durée limitée, en fin:"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "Votre carte-cadeau {{ shop }} d'une valeur de {{ value }}!",
      "subtext": "Voici votre carte-cadeau!",
      "disabled": "Désactivée",
      "expired": "Expirée le {{ expiry }}",
      "active": "Expire le {{ expiry }}",
      "redeem": "Entrez ce code lors du paiement pour utiliser votre carte-cadeau",
      "shop_link": "Boutique",
      "print": "Imprimer"
    }
  },
  "date_formats": {
    "month_day_year": "%d %B, %Y"
  }
}